






























































































import {
  computed,
  defineComponent,
  watch,
  reactive,
  toRefs,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import _ from 'lodash';

import i18n, { i18n_t } from '@/locales/i18n';
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import { getSpeedAndUnit } from '@/renderer/scripts/utils/tools/packages/unit';
import { calcRemainingMessageBySeconds } from '@/renderer/scripts/utils/tools/packages/transmission';
import { SubTask } from '@/renderer/scripts/utils/TaskManager/types';

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    task: {
      type: Object,
      required: true,
      default: null,
    },
    autoHeight: {
      type: Number,
      default: 640,
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    // 本地分页数据
    const pageData = reactive({
      currData: [],
      currPage: 1,
      pageSize: 1000,
      total: 0,
    });
    const pageSizeOptions = [
      {
        label: i18n_t('每页 {slot1} 条', { slot1: 1000 }),
        value: 1000,
      },
    ];
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const detailHeight = computed(() => (pageData.total > 1000 ? props.autoHeight - 69 : props.autoHeight));
    const maxHeight = computed(() => (pageData.total > 1000 ? 640 - 69 : 640)); // 69 分页器高度
    const taskDetailData = computed(() =>
      pageData.currData.map((v: any, index: number) => ({
        ...v,
        index,
      })),
    );

    const methods = {
      calcRemainingMessageBySeconds,
      getSizePercent(item: SubTask<FileInfo>) {
        const { size = 0 } = item.info;
        const { loaded } = item;
        const sizeAndUnit = getSpeedAndUnit(size);
        const loadedSpeed = getSpeedAndUnit(loaded || 0);
        if (item.status === 'success') {
          return `${sizeAndUnit.speed}${sizeAndUnit.unit}`;
        }
        return `${loadedSpeed.speed}${loadedSpeed.unit}/${sizeAndUnit.speed}${sizeAndUnit.unit}`;
      },
      onEventProxy(command: string) {
        if (command === 'cancelTask') {
          innerShow.value = false;
        }
        context.emit('action', {
          command,
          task: props.task,
          actionType: props.task.action,
        });
      },
      // 获取分页数据函数
      getPageData(current: number, pageSize: number) {
        if (props.task.getList()) {
          pageData.total = props.task.getListLength();
          const start: number = pageSize * (current - 1);
          const end: number = current * pageSize;
          pageData.currData = props.task.getList().slice(start, end);
        }
      },
      onPageSizeChange(pageSize: number, pageInfo: any) {
        pageData.pageSize = pageSize;
        methods.getPageData(pageInfo.current, pageSize);
      },
      onCurrentChange(current: number, pageInfo: any) {
        pageData.currPage = current;
        methods.getPageData(current, pageInfo.pageSize);
      },
      percentFunc(item: any) {
        return `${item.percent * 100}%`;
      },
      backClose() {
        context.emit('update:show', false);
      },
    };

    // 监听show的变化,当为show的时候渲染数据
    watch(
      () => props.show,
      val => {
        // 每次弹窗重新打开重置当前页和pageSize
        if (val) {
          pageData.currPage = 1;
          pageData.pageSize = 1000;
          methods.getPageData(pageData.currPage, pageData.pageSize);
        }
      },
    );

    return {
      innerShow,
      ...toRefs(pageData),
      pageSizeOptions,
      detailHeight,
      maxHeight,
      taskDetailData,
      ...methods,
    };
  },
});
